import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/organizations",
        component: List,
        name: "organizations-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/organizations/:id/edit",
        component: Edit,
        name: "organizations-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/organizations/create",
        component: Create,
        name: "organizations-create",
        meta: {
            requiresAuth: true,
        },
    },
];
